import { render, staticRenderFns } from "./comparisons.vue?vue&type=template&id=6511aff4&scoped=true"
import script from "./comparisons.vue?vue&type=script&lang=js"
export * from "./comparisons.vue?vue&type=script&lang=js"
import style0 from "./comparisons.vue?vue&type=style&index=0&id=6511aff4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6511aff4",
  null
  
)

export default component.exports